import { priceProperties } from "./price-properties";
export const PriceDetailsData = {
  data() {
    return {
      ...priceProperties,
      tableHeaders: [
        {
          text: "Day",
          align: "left",
          name: "day",
          sortable: false,
          value: "day",
        },
        {
          text: "Adult Cost",
          align: "left",
          name: "adultBuy",
          sortable: false,
          value: "adultBuy",
        },
        {
          text: "Adult Sell",
          align: "left",
          name: "adultSell",
          sortable: false,
          value: "adultSell",
        },
        {
          text: "Child Cost",
          align: "left",
          name: "childBuy",
          sortable: false,
          value: "childBuy",
        },
        {
          text: "Child Sell",
          align: "left",
          name: "childSell",
          sortable: false,
          value: "childSell",
        },
        {
          text: "Infant Cost",
          align: "left",
          name: "infantBuy",
          sortable: false,
          value: "infantBuy",
        },
        {
          text: "Infant Sell",
          align: "left",
          name: "infantSell",
          sortable: false,
          value: "infantSell",
        },
      ],
      tablePIHeaders: [
        {
          text: "Day",
          align: "left",
          name: "day",
          sortable: false,
          value: "day",
        },
        {
          text: "Cost",
          align: "left",
          name: "adultBuy",
          sortable: false,
          value: "adultBuy",
        },
        {
          text: "Sell",
          align: "left",
          name: "adultSell",
          sortable: false,
          value: "adultSell",
        },
      ],
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/gt/suppliers/supplier-rates/edit/price-details/PriceDetailsEditorDataMixin.js